import { DynamicFormLocale } from '@atlas/dynamic-form-client';
import entries from 'lodash/entries';
import get from 'lodash/get';
import T from 'prop-types';
import React from 'react';
import { useTranslations } from 'srcAlias/global/locale';
import { getQueryStringValueByKey } from 'srcAlias/utils/url';

export const getMatchingStandaloneConfig = config => {
  const standalonesConfig = get(config, 'standalones', []);

  for (const data of standalonesConfig) {
    const { componentName, rules, translationsScope } = data;
    const queryRules = entries(get(rules, 'query', {}));

    const isValid =
      queryRules.length &&
      queryRules.every(([key, value]) => {
        const queryStringValue = getQueryStringValueByKey(key);

        return (
          (queryStringValue !== null && value === '*') ||
          queryStringValue === value
        );
      });

    if (isValid) {
      return {
        componentName,
        translationsScope,
      };
    }
  }

  return {};
};

export const WithDynamicFormLocale = ({ children, translationsScope }) => {
  const translations = useTranslations();

  return (
    <DynamicFormLocale
      translations={{
        definitions: translations.definitions,
        global: translations.global,
        ...get(translations, translationsScope, {}),
      }}
    >
      {children}
    </DynamicFormLocale>
  );
};

WithDynamicFormLocale.propTypes = {
  children: T.node.isRequired,
  translationsScope: T.string,
};
